import Thankyouscreen from "../components/HealthAssessmentForm/Thankyouscreen"
const Thankyou=()=>{
return (
    <Thankyouscreen/>
)
}
export default Thankyou